'use es6';

import promiseClient from 'hub-http/adapters/promiseClient';
import { hubapi } from 'hub-http/middlewares/hubapi';
import { createHubSpotterStack } from './stacks/hubSpotter';
const apiHubSpotterClient = promiseClient(createHubSpotterStack(hubapi));
export default (({
  ignoreRedirect = false
} = {}) => apiHubSpotterClient.get('/internal-login/v1/sessions', {
  ignoreRedirect
}));